module.exports = __webpack_public_path__ + "img/202509_07.46d781b1.jpg";